"use client";
import React from "react";
import Image from "./webflow_modules/Basic/components/Image";

export function FeaturedSlideImage({
  featuredSlideImageImage = "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/656beec750c7f84477e2c301_Rectangle%2093.png",
}) {
  return (
    <Image
      alt={""}
      className={"featured_slide-image"}
      height={"auto"}
      loading={"lazy"}
      src={featuredSlideImageImage}
      width={"auto"}
    />
  );
}
